<template>
  <vue-particles
    id="tsparticles"
    :particlesInit="particlesInit"
    :options="options"
  />
</template>

<script setup>
// define color prop
const props = defineProps(["color"]);

const particleColor = props.color ? props.color : "#ffffff";

let options = {
  background: {
    color: {
      value: "transparent",
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: {
        enable: false,
      },
      onHover: {
        enable: false,
      },
      resize: true,
    },
  },
  particles: {
    color: {
      value: particleColor
    },
    move: {
      direction: "top",
      enable: true,
      outMode: "out",
      random: true,
      speed: 2,
      straight: true,
    },
    number: {
      density: {
        enable: true,
        area: 800,
      },
      value: 40,
    },
    opacity: {
      value: 0.7,
    },
    shape: {
      type: "circle",
    },
    size: {
      random: true,
      value: 15,
    },
  },
  detectRetina: true,
};

import { loadSlim } from "tsparticles-slim";
const particlesInit = async (engine) => {
  //await loadFull(engine);
  await loadSlim(engine);
};
</script>
